import React from 'react';

const IframeEYBLearning = ({src, title,height="85vh", width= "100%", style= {}}) => {

    const iframeStyle = {
        border: "none",
        width: width,
        height: height,
        ...style
    }

return(
    <iframe
    src={src}
    title={title}
    style={iframeStyle}
    />
)
}

export default IframeEYBLearning;